import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import App from './App'
import { i18nSpreman } from './i18n'
import { pokreniPratnjuIzdanja } from './pwa/izdanje'
import './styles/index.css'

const korijen = document.getElementById('root')
if (!korijen) throw new Error('Nedostaje #root — index.html je promijenjen?')

/*
  RJEČNIK PRIJE PRVOG KADRA (dotjerivanje-3 §4).

  Aktivni jezik je od ovog kruga vlastiti chunk (`i18n/index.ts`), pa `render`
  čeka da stigne. Bez čekanja bi gost s hrvatskim jezikom prvo dobio kadar
  engleskog, pa zamjenu pod prstom — a to je vidljiviji trošak od nekoliko
  milisekundi koje se ovdje čekaju (rječnik je u istom builda i dohvaća se
  paralelno s ostalim chunkovima).

  Pad dohvata ne zaustavlja ništa: backend tada odgovori prazno i sučelje ostaje
  na rezervnom jeziku, koji je ugrađen.
*/
void i18nSpreman.finally(() => {
  createRoot(korijen).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})

// PWA (CLAUDE.md §13). Service worker se registrira samo u izgrađenoj verziji:
// u devu bi presretao Viteov HMR i vraćao zastarjele module. Registracija i
// pratnja izdanja idu zajedno (`pwa/izdanje.ts`) — radnik koji preuzima odmah
// mora stranici i reći da ju je preuzeo, inače ostaje sa starim chunkovima.
if (import.meta.env.PROD) {
  // Modul se izvodi i nakon `load` događaja (skripta je `type="module"`), pa se
  // slušač ne bi uvijek okinuo.
  if (document.readyState === 'complete') pokreniPratnjuIzdanja()
  else globalThis.addEventListener('load', () => void pokreniPratnjuIzdanja(), { once: true })
}
